<template>
    <b-modal ref="AddingPurchaseCostToPackageModal" :title="`Package № ${priceData.package_nr}`"
             :no-close-on-backdrop="true">
        <div>
            <b-row>
                <b-col>
                    <label>{{$t('labels.operations.purchase_price_tonnes')}}</label>
                    <input type="number" class="form-control" v-model="priceData.purchase_price"
                           @input="calculatePurchasePrice">
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label>{{$t('labels.operations.defect_perc_per_tonnes')}}</label>
                    <input type="number" class="form-control" v-model="priceData.penalty_perc"
                           @input="calculatePurchasePrice">
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label>{{$t('labels.operations.defect_cost_per_tonnes')}}</label>
                    <input type="number" class="form-control" v-model="priceData.penalty"
                           @input="calculatePurchasePrice">
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label>{{$t('labels.operations.purchase_price')}}</label>
                    <input type="number" class="form-control" v-model="priceData.full_purchase_price" disabled>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label>{{$t('labels.operations.purchase_price_comment')}}</label>
                    <input type="text" class="form-control" v-model="priceData.comment">
                </b-col>
            </b-row>
        </div>
        <div slot="modal-footer" class="w-100 text-center">
            <b-btn size="sm" variant="success" @click="editPurchasePrice">
                {{$t('buttons.common.save')}}
            </b-btn>
        </div>
    </b-modal>
</template>

<script>
  import { handlerResponse } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { Decimal } from 'decimal.js'

  export default {
    props: ['fetchCallback'],
    data() {
      return {
        priceData: {
          package_nr: '',
          weight: 0,
          purchase_price: 0,
          penalty_perc: 0,
          penalty: 0,
          full_purchase_price: 0,
          comment: ''
        }
      }
    },
    methods: {
      calculatePurchasePrice() {
        if (this.priceData.penalty_perc != null && this.priceData.penalty != null) {
          try {
            this.priceData.full_purchase_price = Decimal.mul(
              this.priceData.weight,
              Decimal.add(
                Decimal.mul(this.priceData.penalty_perc, this.priceData.penalty).div('100'),
                Decimal.sub('100', this.priceData.penalty_perc).mul(this.priceData.purchase_price).div('100')
              )
            ).toFixed(2)
          } catch (e) {
            this.priceData.full_purchase_price = '';
          }
        }
      },
      editPurchasePrice() {
        const payload = {
          purchase_price: this.priceData.purchase_price,
          penalty: this.priceData.penalty,
          penalty_perc: this.priceData.penalty_perc,
          comment: this.priceData.comment
        };
        this.$http.put(`woodware/movement_data/${this.priceData.id}/`, payload).then(handlerResponse).then(() => {
          this.fetchCallback();
          this.$refs['AddingPurchaseCostToPackageModal'].hide();
        }).catch(error => notificationsRenderer(error.data, 'error'))
      }
    },
    mounted() {
      this.$root.$on('openAddingPurchaseCostToPackageModal', (data) => {
        this.priceData = {...data};
        this.calculatePurchasePrice();
        if (this.$refs['AddingPurchaseCostToPackageModal']) {
          this.$refs['AddingPurchaseCostToPackageModal'].show();
        }
      });
    },
    beforeDestroy() {
      this.$root.$off('openAddingPurchaseCostToPackageModal');
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/modals/AddingPurchaseCostToPacket.vue